import useGetFileData from 'version-two/hooks/useGetFileData';
import AppVideoPlayer from 'version-two/pages/common/AppVideoPlayer/AppVideoPlayer';

function AppVideoPlayerWrapper() {
  const { data, loading } = useGetFileData();
  return <AppVideoPlayer url={data} loading={loading} />;
}

export default AppVideoPlayerWrapper;
